var render, staticRenderFns
import script from "./AdminLicenseRegistryLicense.vue?vue&type=script&lang=js"
export * from "./AdminLicenseRegistryLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0f93a0e')) {
      api.createRecord('b0f93a0e', component.options)
    } else {
      api.reload('b0f93a0e', component.options)
    }
    
  }
}
component.options.__file = "resources/js/pages/AdminLicenseRegistryLicense.vue"
export default component.exports